/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const newsYearList = () => {
		 if($('.js-news-yearList').length) {
			var latest = $('.js-news-latest-year').text();
			var earliest = $('.js-news-earliest-year').text();
			const optionVal = (_num) => {
				if(location.pathname.match(/\d{4}/)){
					// 文字列に正規表現4桁数値が含まれていたら
					return location.pathname.replace(location.pathname.match(/\d{4}/)[0], _num);
				} else {
					// 文字列に正規表現4桁数値が含まれて無かったら
					return location.pathname.replace('/news/','/news/'+_num+'/');
				}
			};
			// optionを追加
			let optionText = '最新';
			if(location.pathname.split('/')[1] === 'global') {
				optionText = 'Latest';
			}
			let newsVal;
			if(location.pathname.match(/\d{4}/)){
				// 文字列に正規表現4桁数値が含まれていたら
				newsVal = location.pathname.replace(location.pathname.match(/\d{4}/)[0]+'/', '');
			} else {
				// 文字列に正規表現4桁数値が含まれて無かったら
				newsVal = location.pathname;
			}
			$('.js-news-yearList').append($('<option>').html(optionText).val(newsVal));
			for(var i =latest; i>=earliest; i--) {
				$('.js-news-yearList').append($('<option>').html(''+i+'').val(optionVal(i)));
			}
			// 見ている年をselected
			$('.js-news-yearList').val(location.pathname);
			// 選択した年に飛ばす
			$('.js-news-yearList').change(function(){
				location.href = $(this).val();
			});
		}
	};
	const newsCategoryList = () => {
		if($('.js-news-category').length) {
			if(location.pathname.match(/\d{4}/)){
				// 文字列に正規表現4桁数値が含まれていたら
				for(let n = 0; n < $('.js-news-category option').length; n++) {
					let catVal = $('.js-news-category option').eq(n).val().replace('/news/','/news/'+location.pathname.match(/\d{4}/)[0]+'/');
					$('.js-news-category option').eq(n).val(catVal);
					
				}
			}
			// 見ているカテゴリをselected
			$('.js-news-category').val(location.pathname);
			// 選択したカテゴリに飛ばす
			$('.js-news-category').change(function(){
				location.href = $(this).val();
			});
		}
   };
	const newsJson = () => {
		if($('.js-news-json').length) {
			let lang = location.pathname.split('/')[1];
			if(location.pathname.split('/')[1] === 'global') {
				lang = 'glo';
			}
			const getJSONcmsNews = () => {
				return $.getJSON(`/ajax/${lang}/news/all_list.json`);
			};
			const getJSONcmsYearNews = (_year) => {
				return $.getJSON(`/ajax/${lang}/news/${_year}/year_list.json`);
			};
			// const getJSONIr = () => {
			// 	$.ajax({
			// 		type: 'GET',
			// 		url: `https://d3fjlg9o357v7o.cloudfront.net/${location.pathname.split('/')[1]}/ir/ir_release.json`,
			// 		dataType: 'json'
			// 	}).done((ir) => {
			// 		return ir;
			// 	}).fail(function(XMLHttpRequest, textStatus, errorThrown){
			// 		return 'nolist';
			// 	});
			// };
			// Basic認証ID/PASS
			// tamron
			// Yxbnnu4Lz
			// ＜共通＞各jsonを整型→マージ---------------------------------------------------
			const cmsDataMolding = (_cms) => {
				// console.log(_cms,'cmsDataMolding');
				// cmsニュースの配列作成
				let cmsDataList = [];
				for(let i = 0; i < _cms.length; i++) {
					let itemListyear = _cms[i].rt_cf_n_date.content.substr(0,4);
					let itemListmonth = Number(_cms[i].rt_cf_n_date.content.substr(4,2));
					let itemListday = Number(_cms[i].rt_cf_n_date.content.substr(6,2));
					let itemListmonthEn = '';
					switch(itemListmonth) {
						case 1 : itemListmonthEn = 'January'; break;
						case 2 : itemListmonthEn = 'February'; break;
						case 3 : itemListmonthEn = 'March'; break;
						case 4 : itemListmonthEn = 'April'; break;
						case 5 : itemListmonthEn = 'May'; break;
						case 6 : itemListmonthEn = 'June'; break;
						case 7 : itemListmonthEn = 'July'; break;
						case 8 : itemListmonthEn = 'August'; break;
						case 9 : itemListmonthEn = 'September'; break;
						case 10 : itemListmonthEn = 'October'; break;
						case 11 : itemListmonthEn = 'November'; break;
						case 12 : itemListmonthEn = 'December'; break;
						default: itemListmonthEn = 1;
					}
					cmsDataList[i] = {
						jsoncategory: 'cms',
						year: _cms[i].rt_cf_n_date.content.substr(0,4),
						date: _cms[i].rt_cf_n_date.content,
						dateEn: itemListmonthEn+' '+itemListday+', '+itemListyear,
						datekey: _cms[i]._key,
						title: _cms[i].rt_cf_n_title.content,
						pdfSize: _cms[i].rt_cf_n_attachment_file_size,
						newsrelease: _cms[i].cf_n_news_release,
						href: _cms[i].rt_cf_n_href,
						categorygroup: _cms[i].rt_cf_n_category_group_name.content,
						category: _cms[i].rt_cf_n_category_name.content,
						type: _cms[i].cf_n_type,
						tag: _cms[i].cf_n_tags,
					};
				}
				// console.log(cmsDataList,'cmsDataList');
				return cmsDataList;
			};
			const irDataMolding = (_ir) => {
				// console.log(_ir, '_ir');
				// irニュースの配列作成
				let irDataList = [];
				for(let k = 0; k < _ir.length; k++) {
					let itemListyear = _ir[k].PUBLISHED.substr(0,4);
					let itemListmonth = Number(_ir[k].PUBLISHED.substr(4,2));
					let itemListday = Number(_ir[k].PUBLISHED.substr(6,2));
					let itemListmonthEn = '';
					switch(itemListmonth) {
						case 1 : itemListmonthEn = 'January'; break;
						case 2 : itemListmonthEn = 'February'; break;
						case 3 : itemListmonthEn = 'March'; break;
						case 4 : itemListmonthEn = 'April'; break;
						case 5 : itemListmonthEn = 'May'; break;
						case 6 : itemListmonthEn = 'June'; break;
						case 7 : itemListmonthEn = 'July'; break;
						case 8 : itemListmonthEn = 'August'; break;
						case 9 : itemListmonthEn = 'September'; break;
						case 10 : itemListmonthEn = 'October'; break;
						case 11 : itemListmonthEn = 'November'; break;
						case 12 : itemListmonthEn = 'December'; break;
						default: itemListmonthEn = 1;
					}
					irDataList[k] = {
						jsoncategory: 'ir',
						year: _ir[k].PUBLISHED.substr(0,4),
						date: _ir[k].PUBLISHED,
						dateEn: itemListmonthEn+' '+itemListday+', '+itemListyear,
						title: _ir[k].TITLE,
						pdfSize: _ir[k].SIZE,
						target: _ir[k].TARGET,
						href: _ir[k].LINK,
						new: _ir[k].NEW,
						icon: _ir[k].ICON
					};
				}
				// console.log(irDataList,'irDataList');
				return irDataList;
			};
			const itemListMarge = ($cms, $ir) => {
				// 配列をマージ
				let itemList = cmsDataMolding($cms).concat(irDataMolding($ir));
				// 配列を日付・日付キー順でソート
				itemList = _.reverse(_.sortBy(itemList, ['date', 'datekey']))
				return itemList;
			};
			const irListSort = ($ir) => {
				// リスト成型
				let itemList = irDataMolding($ir);
				// 配列を日付順でソート
				itemList.sort(function($itemlista, $itemlistb){
					return($itemlista.date < $itemlistb.date ? 1 : -1);
				});
				return itemList;
			};
			const addyear = ($ir) => {
				// リスト成型
				let itemList = irDataMolding($ir);
				// 配列を日付順でソート
				itemList.sort(function($itemlista, $itemlistb){
					return($itemlista.date < $itemlistb.date ? 1 : -1);
				});
				return itemList;
			};
			// html設定---------------------------------------------------
			const itemListHTML = ($listArray,$loopNum) => {
				let HTML = '';
				if(!$listArray.length) {
					if(location.pathname.split('/')[1] === 'jp') {
						HTML = '<p>現在、最新のニュースはありません。</p>';
					} else {
						HTML = '<p>There is no news.</p>';
					}
				} else {
					$('.js-news-json ul').remove();
					HTML = '<ul>';
					for (let j=0; j < $loopNum; j++) {
						// console.log(j,$listArray[j],'$listArray[j]');
						// 日付日英だし分け
						let _day ='';
						if(location.pathname.split('/')[1] === 'global') {
							_day = '<p class="mod-news-item-top-day ls_en">'+$listArray[j].dateEn+'</p>';
						} else {
							_day = '<p class="mod-news-item-top-day ls_en">'+$listArray[j].year+'.'+$listArray[j].date.substr(4,2)+'.'+$listArray[j].date.substr(6,2)+'</p>';
						}
						if($listArray[j].jsoncategory === 'cms') {
							// ニュースリリースあり・なし判定
							let _newsrelease = '';
							if($listArray[j].newsrelease) {
								if(location.pathname.split('/')[1] === 'jp') {
									_newsrelease = '<div class="mod-news-item-top-category">'+
									'<p class="mod-news-item-category _gray">ニュースリリース</p>'+
									'</div>';
								} else {
									_newsrelease = '<div class="mod-news-item-top-category">'+
									'<p class="mod-news-item-category _gray">News Release</p>'+
									'</div>';
								}
							}
							// リンクタイプ判定
							let _link = '';
							if($listArray[j].type == '1') {
								// フリーレイアウト
								_link = '<a href="'+$listArray[j].href.href+'" class="di_block hov_c_blue">'+
								'<div class="mod-news-item-title mod-spacer-24_16">'+
								'<span>'+$listArray[j].title+'</span>'+
								'</div>'+
								'</a>';
							} else if($listArray[j].type == '2') {
								// 添付ファイル
								function bytesToSize(bytes){
									var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
									if(bytes === 0) {
											return'n/a';
									}
									var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
									if(i === 0) {
											return bytes + ' ' + sizes[i];
									}
									return(bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
								}
								_link = '<a href="'+$listArray[j].href.href+'" class="di_block hov_c_blue" target="'+$listArray[j].href.target+'">'+
								'<div class="mod-news-item-title mod-spacer-24_16">'+
								'<span>'+$listArray[j].title+'</span>'+
								'<svg class="mod-news-item-title-pdf_icon"><use xlink:href="/common/svg/sprite.svg#pdf"></use></svg>'+
								'<span class="mod-news-item-title-file_size">('+bytesToSize($listArray[j].pdfSize.content)+')</span>'+
								'</div>'+
								'</a>';
							} else if($listArray[j].type == '3') {
								// URL指定
								_link = '<a href="'+$listArray[j].href.href+'" class="di_block hov_c_blue" target="'+$listArray[j].href.target+'">'+
								'<div class="mod-news-item-title mod-spacer-24_16">'+
								'<span>'+$listArray[j].title+'</span>'+
								'</div>'+
								'</a>';
							} else if($listArray[j].type == '4') {
								// イベント
								_link = '<a href="'+$listArray[j].href.href+'" class="di_block hov_c_blue">'+
								'<div class="mod-news-item-title mod-spacer-24_16">'+
								'<span>'+$listArray[j].title+'</span>'+
								'</div>'+
								'</a>';
							} else if($listArray[j].type == '5') {
								// テキスト表示
								_link = '<div class="mod-news-item-title mod-spacer-24_16">'+
								'<span>'+$listArray[j].title+'</span>'+
								'</div>';
							}
							// タグ判定
							let _tag = '';
							if($listArray[j].tag) {
								_tag += '<div class="mod-news-item-tag-warpper mod-spacer-24_16_p  hov_c_gray_blue">';
								for (let l=0; l < $listArray[j].tag.length; l++) {
									if(lang === 'jp') {
										_tag += '<p class="mod-news-item-tag"><span class="di_block">#'+$listArray[j].tag[l].cf_nt_name_d_ja+'</span></p>';
									} else {
										_tag += '<p class="mod-news-item-tag"><span class="di_block">#'+$listArray[j].tag[l].cf_nt_name_d_en+'</span></p>';
									}
								}
								_tag += '</div>';
							}
							HTML += '<li class="mod-news-item">'+
							'<div class="mod-news-item-top">'+
							_day+
							_newsrelease+
							'<div class="mod-news-item-top-category"><p class="mod-news-item-category">'+$listArray[j].categorygroup+'</p></div>'+
							'<div class="mod-news-item-top-category"><p class="mod-news-item-category">'+$listArray[j].category+'</p></div>'+
							'</div>'+
							_link+
							_tag+
							'</li>';
						} else if($listArray[j].jsoncategory === 'ir') {
							// リンクタイプ判定
							let _link = '';
							if(!$listArray[j].pdfSize) {
								if(!$listArray[j].href) {
									_link = '<div class="mod-news-item-title mod-spacer-24_16">'+
									'<span>'+$listArray[j].title+'</span>'+
									'</div>';
								} else {
									_link = '<a href="'+$listArray[j].href+'" class="di_block hov_c_blue" target="'+$listArray[j].target+'">'+
									'<div class="mod-news-item-title mod-spacer-24_16">'+
									'<span>'+$listArray[j].title+'</span>'+
									'</div>'+
									'</a>';
								}
							} else {
								_link = '<a href="'+$listArray[j].href+'" class="di_block hov_c_blue" target="_blank">'+
								'<div class="mod-news-item-title mod-spacer-24_16">'+
								'<span>'+$listArray[j].title+'</span>'+
								'<svg class="mod-news-item-title-pdf_icon"><use xlink:href="/common/svg/sprite.svg#pdf"></use></svg>'+
								'<span class="mod-news-item-title-file_size">'+$listArray[j].pdfSize+'</span>'+
								'</div>'+
								'</a>';
							}
							let irText = '';
							if(location.pathname.split('/')[1] === 'jp') {
								irText = '<p class="mod-news-item-category">IR情報</p>';
							} else {
								irText = '<p class="mod-news-item-category">Investor Relations</p>';
							}
							HTML += '<li class="mod-news-item">'+
							'<div class="mod-news-item-top">'+
							_day+
							'<div class="mod-news-item-top-category">'+
							irText+
							'</div>'+
							'</div>'+
							_link+
							'</li>';
						}
					}
					HTML += '</ul>';
				}
				$(HTML).appendTo($('.js-news-json'));
			};
			// ページによってだし分け設定---------------------------------------------------
			if(location.pathname.replace('index.html','') === '/'+location.pathname.split('/')[1]+'/news/') {
				// urlが/$言語$/news/の場合
				getJSONcmsNews().done((cms) => {
					$.ajax({
						type: 'GET',
						url: `https://d3fjlg9o357v7o.cloudfront.net/${location.pathname.split('/')[1]}/ir/ir_release.json`,
						dataType: 'json'
					}).done((ir) => {
						if(!ir) {
							ir = {
								'ir_release' : []
							};
						}
						// console.log(cms,ir);
						// リストをマージ
						let margeList = itemListMarge(cms.rt_bn_news_list,ir.ir_release);
						// console.log(margeList,'margeList');
						// プルダウン設定---------------------------------------------------
						// irリストを成形
						let irList = irListSort(ir.ir_release);
						let optionText = '最新';
						if(location.pathname.split('/')[1] === 'global') {
							optionText = 'Latest';
						}
						// 「最新」を追加
						$('.js-news-yearList-json').append($('<option>').html(optionText).val(location.pathname.replace('index.html','')));
						// 「年」を追加
						let latest = '';
						let earliest = '';
						if(irList.length) {
							// cmsの最新年とirリストの最新年を比較して大きいほうを定義
							let irListLastLatest = Number(irList[0].year);
							let cmsLatest = Number($('.js-news-latest-year').text());
							latest = Math.max(cmsLatest,irListLastLatest);
							// cmsの最古年とirリストの最古年を比較して小さいほうを定義
							let irListLastEarliest = Number(irList.length - 1);
							let cmsEarliest = Number($('.js-news-earliest-year').text());
							earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
						} else {
							latest = Number($('.js-news-latest-year').text());
							earliest = Number($('.js-news-earliest-year').text());
						}
						// 最古年固定で2020
						earliest = 2020;
						for (var i =latest; i>=earliest; i--) {
							$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname + i + '/'));
						}
						// 見ている年をselected
						$('.js-news-yearList-json').val(location.pathname);
						// html設定---------------------------------------------------
						itemListHTML(margeList,20);
					}).fail(function(XMLHttpRequest, textStatus, errorThrown){
						let ir = {
							'ir_release' : []
						};
						// console.log(cms,ir);
						// リストをマージ
						let margeList = itemListMarge(cms.rt_bn_news_list,ir.ir_release);
						// console.log(margeList,'margeList');
						// プルダウン設定---------------------------------------------------
						// irリストを成形
						let irList = irListSort(ir.ir_release);
						let optionText = '最新';
						if(location.pathname.split('/')[1] === 'global') {
							optionText = 'Latest';
						}
						// 「最新」を追加
						$('.js-news-yearList-json').append($('<option>').html(optionText).val(location.pathname.replace('index.html','')));
						// 「年」を追加
						let latest = '';
						let earliest = '';
						if(irList.length) {
							// cmsの最新年とirリストの最新年を比較して大きいほうを定義
							let irListLastLatest = Number(irList[0].year);
							let cmsLatest = Number($('.js-news-latest-year').text());
							latest = Math.max(cmsLatest,irListLastLatest);
							// cmsの最古年とirリストの最古年を比較して小さいほうを定義
							let irListLastEarliest = Number(irList.length - 1);
							let cmsEarliest = Number($('.js-news-earliest-year').text());
							earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
						} else {
							latest = Number($('.js-news-latest-year').text());
							earliest = Number($('.js-news-earliest-year').text());
						}
						// 最古年固定で2020
						earliest = 2020;
						for (var i =latest; i>=earliest; i--) {
							$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname + i + '/'));
						}
						// 見ている年をselected
						$('.js-news-yearList-json').val(location.pathname);
						// html設定---------------------------------------------------
						itemListHTML(margeList,20);
					});
				});
			} else if(location.pathname.split('/')[3].indexOf('20') !== -1) {
				if(!location.pathname.split('/')[4].replace('index.html','')) {
					// urlが/$言語$/news/2xxx/の場合
					getJSONcmsYearNews(location.pathname.split('/')[3]).done((cms) => {
						$.ajax({
							type: 'GET',
							url: `https://d3fjlg9o357v7o.cloudfront.net/${location.pathname.split('/')[1]}/ir/ir_release.json`,
							dataType: 'json'
						}).done((ir) => {
							if(!ir) {
								ir = {
									'ir_release' : []
								};
							}
							// console.log(cms,ir);
							// リストをマージ
							let margeList = itemListMarge(cms.rt_bn_news_list,ir.ir_release);
							let margeListYear = [];
							for(let m = 0; m < margeList.length; m++) {
								if(margeList[m].year == location.pathname.split('/')[3]) {
									margeListYear.push(margeList[m]);
								}
							}
							// console.log(margeListYear,'margeListYear');
							// プルダウン設定---------------------------------------------------
							// irリストを成形
							let irList = irListSort(ir.ir_release);
							let optionText = '最新';
							if(location.pathname.split('/')[1] === 'global') {
								optionText = 'Latest';
							}
							// 「最新」を追加
							$('.js-news-yearList-json').append($('<option>').html(optionText).val('/'+location.pathname.split('/')[1]+'/news/'));
							// 「年」を追加
							let latest = '';
							let earliest = '';
							if(irList.length) {
								// cmsの最新年とirリストの最新年を比較して大きいほうを定義
								let irListLastLatest = Number(irList[0].year);
								let cmsLatest = Number($('.js-news-latest-year').text());
								latest = Math.max(cmsLatest,irListLastLatest);
								// cmsの最古年とirリストの最古年を比較して小さいほうを定義
								let irListLastEarliest = Number(irList.length - 1);
								let cmsEarliest = Number($('.js-news-earliest-year').text());
								earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
							} else {
								latest = Number($('.js-news-latest-year').text());
								earliest = Number($('.js-news-earliest-year').text());
							}
							// 最古年固定で2020
							earliest = 2020;
							for (var i =latest; i>=earliest; i--) {
								$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname.replace(location.pathname.match(/\d{4}/)[0], i)));
							}
							// 見ている年をselected
							$('.js-news-yearList-json').val(location.pathname);
							// カテゴリ設定
							for(let n = 0; n < $('.js-news-category-json option').length; n++) {
								let catVal = $('.js-news-category-json option').eq(n).val().replace('/news/','/news/'+location.pathname.match(/\d{4}/)[0]+'/');
								$('.js-news-category-json option').eq(n).val(catVal);
							}
							// html設定---------------------------------------------------
							itemListHTML(margeListYear,Number(margeListYear.length));
						}).fail(function(XMLHttpRequest, textStatus, errorThrown){
							let ir = {
								'ir_release' : []
							};
							// リストをマージ
							let margeList = itemListMarge(cms.rt_bn_news_list,ir.ir_release);
							let margeListYear = [];
							for(let m = 0; m < margeList.length; m++) {
								if(margeList[m].year == location.pathname.split('/')[3]) {
									margeListYear.push(margeList[m]);
								}
							}
							// console.log(margeListYear,'margeListYear');
							// プルダウン設定---------------------------------------------------
							// irリストを成形
							let irList = irListSort(ir.ir_release);
							let optionText = '最新';
							if(location.pathname.split('/')[1] === 'global') {
								optionText = 'Latest';
							}
							// 「最新」を追加
							$('.js-news-yearList-json').append($('<option>').html(optionText).val('/'+location.pathname.split('/')[1]+'/news/'));
							// 「年」を追加
							let latest = '';
							let earliest = '';
							if(irList.length) {
								// cmsの最新年とirリストの最新年を比較して大きいほうを定義
								let irListLastLatest = Number(irList[0].year);
								let cmsLatest = Number($('.js-news-latest-year').text());
								latest = Math.max(cmsLatest,irListLastLatest);
								// cmsの最古年とirリストの最古年を比較して小さいほうを定義
								let irListLastEarliest = Number(irList.length - 1);
								let cmsEarliest = Number($('.js-news-earliest-year').text());
								earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
							} else {
								latest = Number($('.js-news-latest-year').text());
								earliest = Number($('.js-news-earliest-year').text());
							}
							// 最古年固定で2020
							earliest = 2020;
							for (var i =latest; i>=earliest; i--) {
								$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname.replace(location.pathname.match(/\d{4}/)[0], i)));
							}
							// 見ている年をselected
							$('.js-news-yearList-json').val(location.pathname);
							// カテゴリ設定
							for(let n = 0; n < $('.js-news-category-json option').length; n++) {
								let catVal = $('.js-news-category-json option').eq(n).val().replace('/news/','/news/'+location.pathname.match(/\d{4}/)[0]+'/');
								$('.js-news-category-json option').eq(n).val(catVal);
							}
							// html設定---------------------------------------------------
							itemListHTML(margeListYear,Number(margeListYear.length));
						});
					});
				} else {
					if(!(location.pathname.split('/')[4].replace('index.html','') === 'ir')) {
						// urlが/$言語$/news/2xxx/$カテゴリ$/の場合(ir以外)
						$('.js-news-json ul').removeClass('di_none');
						// プルダウン設定---------------------------------------------------
						$.ajax({
							type: 'GET',
							url: `https://d3fjlg9o357v7o.cloudfront.net/${location.pathname.split('/')[1]}/ir/ir_release.json`,
							dataType: 'json'
						}).done((ir) => {
							if(!ir) {
								ir = {
									'ir_release' : []
								};
							}
							// irリストを成形
							let irList = irListSort(ir.ir_release);
							let optionText = '最新';
							if(location.pathname.split('/')[1] === 'global') {
								optionText = 'Latest';
							}
							// 「最新」を追加
							$('.js-news-yearList-json').append($('<option>').html(optionText).val(location.pathname.replace(location.pathname.match(/\d{4}/)[0]+'/','')));
							// 「年」を追加
							let latest = '';
							let earliest = '';
							if(irList.length) {
								// cmsの最新年とirリストの最新年を比較して大きいほうを定義
								let irListLastLatest = Number(irList[0].year);
								let cmsLatest = Number($('.js-news-latest-year').text());
								latest = Math.max(cmsLatest,irListLastLatest);
								// cmsの最古年とirリストの最古年を比較して小さいほうを定義
								let irListLastEarliest = Number(irList.length - 1);
								let cmsEarliest = Number($('.js-news-earliest-year').text());
								earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
							} else {
								latest = Number($('.js-news-latest-year').text());
								earliest = Number($('.js-news-earliest-year').text());
							}
							// 最古年固定で2020
							earliest = 2020;
							for (var i =latest; i>=earliest; i--) {
								$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname.replace(location.pathname.match(/\d{4}/)[0], i)));
							}
							// 見ている年をselected
							$('.js-news-yearList-json').val(location.pathname);
							// カテゴリ設定
							for(let n = 0; n < $('.js-news-category-json option').length; n++) {
								let catVal = $('.js-news-category-json option').eq(n).val().replace('/news/','/news/'+location.pathname.match(/\d{4}/)[0]+'/');
								$('.js-news-category-json option').eq(n).val(catVal);
							}
							// 見ているカテゴリをselected
							$('.js-news-category-json').val(location.pathname);
						}).fail(function(XMLHttpRequest, textStatus, errorThrown){
							let ir = {
								'ir_release' : []
							};
							// irリストを成形
							let irList = irListSort(ir.ir_release);
							let optionText = '最新';
							if(location.pathname.split('/')[1] === 'global') {
								optionText = 'Latest';
							}
							// 「最新」を追加
							$('.js-news-yearList-json').append($('<option>').html(optionText).val(location.pathname.replace(location.pathname.match(/\d{4}/)[0]+'/','')));
							// 「年」を追加
							let latest = '';
							let earliest = '';
							if(irList.length) {
								// cmsの最新年とirリストの最新年を比較して大きいほうを定義
								let irListLastLatest = Number(irList[0].year);
								let cmsLatest = Number($('.js-news-latest-year').text());
								latest = Math.max(cmsLatest,irListLastLatest);
								// cmsの最古年とirリストの最古年を比較して小さいほうを定義
								let irListLastEarliest = Number(irList.length - 1);
								let cmsEarliest = Number($('.js-news-earliest-year').text());
								earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
							} else {
								latest = Number($('.js-news-latest-year').text());
								earliest = Number($('.js-news-earliest-year').text());
							}
							// 最古年固定で2020
							earliest = 2020;
							for (var i =latest; i>=earliest; i--) {
								$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname.replace(location.pathname.match(/\d{4}/)[0], i)));
							}
							// 見ている年をselected
							$('.js-news-yearList-json').val(location.pathname);
							// カテゴリ設定
							for(let n = 0; n < $('.js-news-category-json option').length; n++) {
								let catVal = $('.js-news-category-json option').eq(n).val().replace('/news/','/news/'+location.pathname.match(/\d{4}/)[0]+'/');
								$('.js-news-category-json option').eq(n).val(catVal);
							}
							// 見ているカテゴリをselected
							$('.js-news-category-json').val(location.pathname);
						});
					} else {
						// urlが/$言語$/news/2xxx/ir/の場合
						$.ajax({
							type: 'GET',
							url: `https://d3fjlg9o357v7o.cloudfront.net/${location.pathname.split('/')[1]}/ir/ir_release.json`,
							dataType: 'json'
						}).done((ir) => {
							if(!ir) {
								ir = {
									'ir_release' : []
								};
							}
							// irリストを成形
							let irList = irListSort(ir.ir_release);
							let irListYear = [];
							for(let m = 0; m < irList.length; m++) {
								if(irList[m].year == location.pathname.split('/')[3]) {
									irListYear.push(irList[m]);
								}
							}
							// console.log(irListYear,'irListYear');
							// プルダウン設定---------------------------------------------------
							let optionText = '最新';
							if(location.pathname.split('/')[1] === 'global') {
								optionText = 'Latest';
							}
							// 「最新」を追加
							$('.js-news-yearList-json').append($('<option>').html(optionText).val(location.pathname.replace(location.pathname.match(/\d{4}/)[0]+'/','')));
							// 「年」を追加
							let latest = '';
							let earliest = '';
							if(irList.length) {
								// cmsの最新年とirリストの最新年を比較して大きいほうを定義
								let irListLastLatest = Number(irList[0].year);
								let cmsLatest = Number($('.js-news-latest-year').text());
								latest = Math.max(cmsLatest,irListLastLatest);
								// cmsの最古年とirリストの最古年を比較して小さいほうを定義
								let irListLastEarliest = Number(irList.length - 1);
								let cmsEarliest = Number($('.js-news-earliest-year').text());
								earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
							} else {
								latest = Number($('.js-news-latest-year').text());
								earliest = Number($('.js-news-earliest-year').text());
							}
							// 最古年固定で2020
							earliest = 2020;
							for (var i =latest; i>=earliest; i--) {
								$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname.replace(location.pathname.match(/\d{4}/)[0], i)));
							}
							// 見ている年をselected
							$('.js-news-yearList-json').val(location.pathname);
							// カテゴリ設定
							for(let n = 0; n < $('.js-news-category-json option').length; n++) {
								let catVal = $('.js-news-category-json option').eq(n).val().replace('/news/','/news/'+location.pathname.match(/\d{4}/)[0]+'/');
								$('.js-news-category-json option').eq(n).val(catVal);
							}
							// 見ているカテゴリをselected
							$('.js-news-category-json').val(location.pathname);
							// html設定---------------------------------------------------
							itemListHTML(irListYear,Number(irListYear.length));
						}).fail(function(XMLHttpRequest, textStatus, errorThrown){
							let ir = {
								'ir_release' : []
							};
							// irリストを成形
							let irList = irListSort(ir.ir_release);
							let irListYear = [];
							for(let m = 0; m < irList.length; m++) {
								if(irList[m].year == location.pathname.split('/')[3]) {
									irListYear.push(irList[m]);
								}
							}
							// console.log(irListYear,'irListYear');
							// プルダウン設定---------------------------------------------------
							let optionText = '最新';
							if(location.pathname.split('/')[1] === 'global') {
								optionText = 'Latest';
							}
							// 「最新」を追加
							$('.js-news-yearList-json').append($('<option>').html(optionText).val(location.pathname.replace(location.pathname.match(/\d{4}/)[0]+'/','')));
							// 「年」を追加
							let latest = '';
							let earliest = '';
							if(irList.length) {
								// cmsの最新年とirリストの最新年を比較して大きいほうを定義
								let irListLastLatest = Number(irList[0].year);
								let cmsLatest = Number($('.js-news-latest-year').text());
								latest = Math.max(cmsLatest,irListLastLatest);
								// cmsの最古年とirリストの最古年を比較して小さいほうを定義
								let irListLastEarliest = Number(irList.length - 1);
								let cmsEarliest = Number($('.js-news-earliest-year').text());
								earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
							} else {
								latest = Number($('.js-news-latest-year').text());
								earliest = Number($('.js-news-earliest-year').text());
							}
							// 最古年固定で2020
							earliest = 2020;
							for (var i =latest; i>=earliest; i--) {
								$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname.replace(location.pathname.match(/\d{4}/)[0], i)));
							}
							// 見ている年をselected
							$('.js-news-yearList-json').val(location.pathname);
							// カテゴリ設定
							for(let n = 0; n < $('.js-news-category-json option').length; n++) {
								let catVal = $('.js-news-category-json option').eq(n).val().replace('/news/','/news/'+location.pathname.match(/\d{4}/)[0]+'/');
								$('.js-news-category-json option').eq(n).val(catVal);
							}
							// 見ているカテゴリをselected
							$('.js-news-category-json').val(location.pathname);
							// html設定---------------------------------------------------
							itemListHTML(irListYear,Number(irListYear.length));
						});
					}
				}
			} else {
				if(!(location.pathname.split('/')[3].replace('index.html','') === 'ir')) {
					// urlが/$言語$/news/$カテゴリ$/の場合(ir以外)
					$('.js-news-json ul').removeClass('di_none');
					// プルダウン設定---------------------------------------------------
					$.ajax({
						type: 'GET',
						url: `https://d3fjlg9o357v7o.cloudfront.net/${location.pathname.split('/')[1]}/ir/ir_release.json`,
						dataType: 'json'
					}).done((ir) => {
						if(!ir) {
							ir = {
								'ir_release' : []
							};
						}
						let optionText = '最新';
						if(location.pathname.split('/')[1] === 'global') {
							optionText = 'Latest';
						}
						// 「最新」を追加
						$('.js-news-yearList-json').append($('<option>').html(optionText).val(location.pathname));
						// 「年」を追加
						let irList = irListSort(ir.ir_release);
						let latest = '';
						let earliest = '';
						if(irList.length) {
							// cmsの最新年とirリストの最新年を比較して大きいほうを定義
							let irListLastLatest = Number(irList[0].year);
							let cmsLatest = Number($('.js-news-latest-year').text());
							latest = Math.max(cmsLatest,irListLastLatest);
							// cmsの最古年とirリストの最古年を比較して小さいほうを定義
							let irListLastEarliest = Number(irList.length - 1);
							let cmsEarliest = Number($('.js-news-earliest-year').text());
							earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
						} else {
							latest = Number($('.js-news-latest-year').text());
							earliest = Number($('.js-news-earliest-year').text());
						}
						// 最古年固定で2020
						earliest = 2020;
						for (var i =latest; i>=earliest; i--) {
							$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname.replace('/news/','/news/'+i+'/')));
						}
						// 見ている年をselected
						$('.js-news-yearList-json').val(location.pathname);
						// 見ているカテゴリをselected
						$('.js-news-category-json').val(location.pathname);
					}).fail(function(XMLHttpRequest, textStatus, errorThrown){
						let ir = {
							'ir_release' : []
						};
						if(!ir) {
							ir = {
								'ir_release' : []
							};
						}
						let optionText = '最新';
						if(location.pathname.split('/')[1] === 'global') {
							optionText = 'Latest';
						}
						// 「最新」を追加
						$('.js-news-yearList-json').append($('<option>').html(optionText).val(location.pathname));
						// 「年」を追加
						let irList = irListSort(ir.ir_release);
						let latest = '';
						let earliest = '';
						if(irList.length) {
							// cmsの最新年とirリストの最新年を比較して大きいほうを定義
							let irListLastLatest = Number(irList[0].year);
							let cmsLatest = Number($('.js-news-latest-year').text());
							latest = Math.max(cmsLatest,irListLastLatest);
							// cmsの最古年とirリストの最古年を比較して小さいほうを定義
							let irListLastEarliest = Number(irList.length - 1);
							let cmsEarliest = Number($('.js-news-earliest-year').text());
							earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
						} else {
							latest = Number($('.js-news-latest-year').text());
							earliest = Number($('.js-news-earliest-year').text());
						}
						// 最古年固定で2020
						earliest = 2020;
						for (var i =latest; i>=earliest; i--) {
							$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname.replace('/news/','/news/'+i+'/')));
						}
						// 見ている年をselected
						$('.js-news-yearList-json').val(location.pathname);
						// 見ているカテゴリをselected
						$('.js-news-category-json').val(location.pathname);
					});
				} else {
					// urlが/$言語$/news/ir/の場合
					$.ajax({
						type: 'GET',
						url: `https://d3fjlg9o357v7o.cloudfront.net/${location.pathname.split('/')[1]}/ir/ir_release.json`,
						dataType: 'json'
					}).done((ir) => {
						if(!ir) {
							ir = {
								'ir_release' : []
							};
						}
						// プルダウン設定---------------------------------------------------
						// irリストを成形
						let irList = irListSort(ir.ir_release);
						let optionText = '最新';
						if(location.pathname.split('/')[1] === 'global') {
							optionText = 'Latest';
						}
						// 「最新」を追加
						$('.js-news-yearList-json').append($('<option>').html(optionText).val(location.pathname));
						// 「年」を追加
						let latest = '';
						let earliest = '';
						if(irList.length) {
							// cmsの最新年とirリストの最新年を比較して大きいほうを定義
							let irListLastLatest = Number(irList[0].year);
							let cmsLatest = Number($('.js-news-latest-year').text());
							latest = Math.max(cmsLatest,irListLastLatest);
							// cmsの最古年とirリストの最古年を比較して小さいほうを定義
							let irListLastEarliest = Number(irList.length - 1);
							let cmsEarliest = Number($('.js-news-earliest-year').text());
							earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
						} else {
							latest = Number($('.js-news-latest-year').text());
							earliest = Number($('.js-news-earliest-year').text());
						}
						// 最古年固定で2020
						earliest = 2020;
						for (var i =latest; i>=earliest; i--) {
							$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname.replace('/news/','/news/'+i+'/')));
						}
						// 見ている年をselected
						$('.js-news-yearList-json').val(location.pathname);
						// 見ているカテゴリをselected
						$('.js-news-category-json').val(location.pathname);
						// html設定---------------------------------------------------
						itemListHTML(irList,20);
					}).fail(function(XMLHttpRequest, textStatus, errorThrown){
						let ir = {
							'ir_release' : []
						};
						// プルダウン設定---------------------------------------------------
						// irリストを成形
						let irList = irListSort(ir.ir_release);
						let optionText = '最新';
						if(location.pathname.split('/')[1] === 'global') {
							optionText = 'Latest';
						}
						// 「最新」を追加
						$('.js-news-yearList-json').append($('<option>').html(optionText).val(location.pathname));
						// 「年」を追加
						let latest = '';
						let earliest = '';
						if(irList.length) {
							// cmsの最新年とirリストの最新年を比較して大きいほうを定義
							let irListLastLatest = Number(irList[0].year);
							let cmsLatest = Number($('.js-news-latest-year').text());
							latest = Math.max(cmsLatest,irListLastLatest);
							// cmsの最古年とirリストの最古年を比較して小さいほうを定義
							let irListLastEarliest = Number(irList.length - 1);
							let cmsEarliest = Number($('.js-news-earliest-year').text());
							earliest = Math.min(cmsEarliest,irList[irListLastEarliest].year);
						} else {
							latest = Number($('.js-news-latest-year').text());
							earliest = Number($('.js-news-earliest-year').text());
						}
						// 最古年固定で2020
						earliest = 2020;
						for (var i =latest; i>=earliest; i--) {
							$('.js-news-yearList-json').append($('<option>').html(''+i+'').val(location.pathname.replace('/news/','/news/'+i+'/')));
						}
						// 見ている年をselected
						$('.js-news-yearList-json').val(location.pathname);
						// 見ているカテゴリをselected
						$('.js-news-category-json').val(location.pathname);
						// html設定---------------------------------------------------
						itemListHTML(irList,20);
					});

				}
			}
			// プルダウン処理---------------------------------------------------
			$('.js-news-category-json').change(function(){
				location.href = $(this).val();
			});
			$('.js-news-yearList-json').change(function(){
				location.href = $(this).val();
			});
		}
	};
	newsYearList();
	newsCategoryList();
	newsJson();

})(window.jQuery, window.FUNCTIONS);
